import Styled from 'styled-components';
import COLORS from '../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../common/styles/fontStyles';

const AdvertisingContainer = Styled.div<{ noMarginRight?: boolean }>`
  display: flex;
  flex-direction: column;
  align-self: flex-end;
  margin-right: ${(p) => (p.noMarginRight ? '0' : '-33px')};
  & > div:not(:last-child){
    margin-bottom: 20px;
  }
  @media only screen and (max-width: 991px) {
    align-self: auto;
    margin: 30px 0;
  }
`;

const AdvertisingWrapper = Styled.div<{ subContent: boolean }>`
  display: flex;
  flex-direction: row;
  width: ${(p) => (p.subContent ? '455px' : '426px')};
  height: fit-content;
  border-radius: 4px;
  background-color: ${COLORS.brandSecondary};
  overflow: hidden;
  box-sizing: border-box;
  font-family: ${FONT_FAMILY.default.regular};
  @media only screen and (max-width: 991px) {
    width: 100%;
  }
  .bannerContent{
    flex:2;
    padding: ${(p) => (p.subContent ? '8px' : '14px')} 20px;
    padding-right: 5px;
    background-color: ${COLORS.black};
    border-bottom-right-radius: 100px;
  }
  
  .bannerHeading {
    font-family: ${FONT_FAMILY.default.bold};
    color: ${COLORS.white};
    font-size: 14px;
    line-height: 17px;
  }

  .bannerSubHeading{
    font-size: 14px;
    color: ${COLORS.white};
    line-height: 18px;
    letter-spacing: .5px;
  }
  
  .advertise-btn{
    padding: 14px 20px;
    width: fit-content;
    outline: none;
    border: none;
    font-size: 14px;
    padding-left: 5px;
    cursor: pointer;
    align-self: center;
    font-family: ${FONT_FAMILY.default.bold};
    background-color: ${COLORS.brandSecondary};
    text-decoration: none;
    color: ${COLORS.black};
    display: flex;
    align-items: center;
    img {
      float: none;
      margin-right: 4px;
    }
  }
`;

const ModalContainer = Styled.div`
  width: 500px;
  background-color: ${COLORS.white};
  box-sizing: border-box;
  position: relative;
  border-radius: 10px;
  & .close-icon {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
  }
  & .model-content{
    margin-bottom: 30px;
    text-align: center;
    h2{
      font-size: 24px;
      line-height: 38px;
      color: ${COLORS.black};
      margin-bottom: 15px;
    }
    p{
      font-size: 16px;
      color: ${COLORS.textGrey};
    }
  }
  & .btn-wrapper {
    display: flex;
    justify-content: center;
    & :not(:last-child){
      margin-right: 30px;
    }
  }
  & .btn-wrapper .default-btn {
    padding: 15px 28px;
    color: ${COLORS.black};
    background-color: ${COLORS.brandSecondary};
    cursor: pointer;
    font-family: ${FONT_FAMILY.default.bold};
    width: fit-content;
    min-width: 150px;
    outline: none;
    border: none;
    font-size: 16px;
    border-radius: 4px;
  }
`;
const BannerPopUPWrapper = Styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding:16px;
  margin-bottom:32px;
  .image{
    width:250px;
    height:295px;
    margin:24px 0;

  }
  .heading{
    font-size:18px;
    line-height:26px;
    font-family: ${FONT_FAMILY.hellix.bold};
    color: ${COLORS.black}
  }
  .sub-content {
    margin:24px 0 ;
    border: 1px solid ${COLORS.borderGrey};
    padding: 12px;
    white-space: pre-wrap;
 }
 .sub-heading{
  font-size:18px;
  line-height:24px;
  font-family: ${FONT_FAMILY.hellix.regular};
  color: ${COLORS.textGrey};
  white-space: pre-wrap;
}
`;
export const Dot = Styled.div`
  display: inline-block;
  width: 6px;
  height: 6px;
  background-color: black;
  border-radius: 50%;
  margin-right: 8px;

`;

export { AdvertisingContainer, AdvertisingWrapper, ModalContainer, BannerPopUPWrapper };
